import "./styles/main.css";

import { Experience } from "./Experience/Experience.js";

const canvas = document.getElementById("webgl-canvas");

if (canvas) {
  const experience = new Experience({ canvas });
  experience.init().catch((error) => {
    // Keep failure visible to user without crashing page.
    console.error("Failed to initialize experience", error);
  });
}
